import { IEntity } from "@interfaces/entity";
import { ChargingPower } from "./chargingPower";
import { ConnectorSystems } from "./connectorSystems";
import { User } from "./identity/user";
import { Manufacturer } from "./manufacturer";
import { RfidCard } from "./rfidCard";
import { Pricing } from "./pricing";
import { ChargingStationStatus } from "./chargingStationStatus";
import { Customer } from "./customer";
import { Address } from "./address";
import { ChargingStationDlm } from "./ChargingStationDlm";
import { Model } from "./model";
import { Profile } from "./profile"
import { ChargingstationGroupDto } from "@dto/chragingstationGroupDto";
import { ChargingPoint } from "./chargingPoint";

export class ChargingStation implements IEntity {
  id: string;
  name: string;
  lat: string;
  lon: string;
  location: string;
  addressId: number;
  address: Address;
  manufacturer: Manufacturer;
  manufacturerId: number;
  model: Model;
  modelId: number;
  profileId: number;
  profile: Profile;
  serialNumber: string;
  chargePointSerialNumber: string;
  installationDate: Date;
  connectorSystems: ConnectorSystems;
  connectorSystemsId: number;
  chargingPowerId: number;
  chargingPower: ChargingPower;
  chargingPowerName: string;
  cableLength: string;

  // charging station status -> connector id 0. also see charging point status.
  statusId: number;
  status: ChargingStationStatus;

  displayStatus: string;
  isFreeCharge: boolean;
  isPublicCharge: boolean;
  isPrivateCharge: boolean;
  firmware: string;
  isScanModeActive: boolean;
  pricings: Pricing[];
  chargingPoints: ChargingPoint[];
  
  customerId: number;
  customer: Customer;
  dlmMapping: any;
  allowedRfidCards: RfidCard[];
  allowedUsers: User[];

  key: string;

  localIP: string;

  chargingStationDlmId: number;
  chargingStationDlm: ChargingStationDlm;
  chargingstationGroupsDto: ChargingstationGroupDto[];
  evseId: string;
  offlineSince: Date;
  csId: string;
  isHubjectAvailable: boolean;
  isHubjectCompatible: boolean;
  displayChargeMode: string;
  offlineStatusReported: boolean;
  displayOffLineReported: string;


  entityName = "ChargingStation";

  constructor(formValue?: Partial<ChargingStation>) {
    Object.assign(this, formValue);
  }

  updateValues(formValue: Partial<ChargingStation>) {
    Object.assign(this, formValue);
  }

  getPrimaryKey() {
    return this.id;
  }
}
